import React from 'react';
import {
  FDAvatar, FDClickableText, FDPaper, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { BodyTextMedium, TitleTextLarge } from 'Packages/FacetDesign/Components';
import moment from 'moment/moment';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs } from 'Helpers/Testing';

const ScheduledMeetingDetails = ({
  meetingName, meetingStartTime, meetingEndTime, meetingDuration, agentProfileImageLink, rescheduleLink, onReschedule,
}) => {
  const isMobile = useMobileLayout();

  // If we're missing info, don't render the details right now. For example, Chilipiper may not have gotten back to us with info we need
  if (!meetingName || !meetingStartTime || !meetingEndTime) {
    return null;
  }
  if ((rescheduleLink && !onReschedule) || (onReschedule && !rescheduleLink)) {
    throw new Error('Both onReschedule and rescheduleLink must be provided if either is provided');
  }

  const starTime = moment(meetingStartTime).format('MMM D, YYYY h:mm A');
  const endTime = moment(meetingEndTime).format('h:mm A');

  const topLevelDirection = isMobile ? 'column' : 'row';
  const mainContentAlignment = isMobile ? 'center' : 'flex-start';
  const textAlignment = isMobile ? 'center' : 'start';

  return (
    <FDPaper appearance={'elevated'} padding={2} {...dataAttrs('scheduled-meeting-details')}>
      <FDStack direction={topLevelDirection} spacing={2}>
        {
          agentProfileImageLink
            ? (
              <FDStack direction={'column'} spacing={1} alignItems={'center'} justifyContent={'center'}>
                <FDAvatar alt={agentProfileImageLink.meta('altText')} src={agentProfileImageLink.link('related').url()} size={'xl'} />
              </FDStack>
            )
            : null
        }
        <FDStack direction={'column'} spacing={1} justifyContent={mainContentAlignment} alignItems={mainContentAlignment}>
          <TitleTextLarge value={meetingName} />
          <FDStack direction={'column'}>
            <BodyTextMedium value={`${starTime} - ${endTime}, ${meetingDuration}min`} color={'textDisabled'} align={textAlignment} />
          </FDStack>
          {rescheduleLink && (
          <BodyTextMedium color={'textSecondary'} value={<FDClickableText onClick={onReschedule} appearance={'standalone'} label={rescheduleLink.meta('prompt')} />} />
          )}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

ScheduledMeetingDetails.defaultProps = {
  rescheduleLink: null,
  onReschedule: null,
};

ScheduledMeetingDetails.propTypes = {
  meetingName: PropTypes.string.isRequired,
  meetingStartTime: PropTypes.string.isRequired,
  meetingEndTime: PropTypes.string.isRequired,
  meetingDuration: PropTypes.string.isRequired,
  agentProfileImageLink: PropTypes.object.isRequired,
  rescheduleLink: PropTypes.object,
  onReschedule: PropTypes.func,
};

export default ScheduledMeetingDetails;
